module.exports = __webpack_public_path__ + "img/monitor6.34b27700.jpg";